const borderWidth3 = "4px";
const borderWidth2 = "2px";
const borderWidth1 = "1px";
const borderWidth0 = "0px";
const borderWidth = {
  borderWidth3,
  borderWidth2,
  borderWidth1,
  borderWidth0
};
export {
  borderWidth0,
  borderWidth1,
  borderWidth2,
  borderWidth3,
  borderWidth as default
};
//# sourceMappingURL=index.es12.js.map
